import IgSetHeaders from "@/api/ins_api_new/persisits/ig_set_headers";
import { isIos } from "@/utils/lodash";
import PresisiteAPIParams from "../persisits/lunch_params";

export function creatUUid(length: number = 36, upper: boolean = true) {
  const uid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"
    .replace(/[xy]/g, (c: any) => {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    })
    .slice(0, length);
  return upper ? uid.toUpperCase() : uid;
}

export const cg_api_signed_body = (params: any) => {
  return {
    signed_body: "SIGNATURE." + JSON.stringify(params)
  };
};

export const cg_api_random_loop_count = (
  taken_at: number,
  time_now: number,
  video_duration: number
) => {
  if (time_now - video_duration < taken_at + 2) {
    return 0;
  }
  if (video_duration <= 0) {
    return 0;
  }
  const max_count = Math.floor(
    (time_now - video_duration - taken_at) / video_duration
  );
  // if (max_count === 0) {
  //   let time_watch = taken_at + 1 + TimeInterval(Math.random() * 10) / 10;
  //   return (time_now - time_watch) / video_duration;
  // }
  // max_count = min(max_count, 5);
  // let loop_count = TimeInterval(Math.random() * max_count + 1);
  // return loop_count - TimeInterval(Math.random() * 10) / 10;
};

export const handleIgHeaders = (
  headers: Record<string, string>,
  user_id: string = ""
) => {
  const userId = user_id ? "" + user_id : "unkown";
  console.log("handleIgHeaders headers", headers, "user_id", userId);
  const ignoreIGSetKeys: string = "use-auth-header-for-sso";
  const cachHeaders: Record<string, string> = {};
  Object.keys(headers).forEach(key => {
    const lowerKey = key.toLocaleLowerCase();
    let value = headers[key];
    if (!isIos()) {
      const lastChart = value.slice(value.length - 1);
      if (lastChart === ";") {
        value = value.slice(0, value.length - 1);
      }
    }
    if (lowerKey === "ig-set-password-encryption-key-id") {
      PresisiteAPIParams.catchEncryptionKeyId(value);
    } else if (lowerKey === "ig-set-password-encryption-pub-key") {
      PresisiteAPIParams.catchEncryptionPubKey(value);
    } else if (lowerKey.includes("ig-set-")) {
      const realKey = lowerKey.slice(7);
      if (value) {
        if (realKey === "x-mid") {
          PresisiteAPIParams.catchApiMid(value);
        } else if (realKey === "authorization") {
          if (value.length > "Bearer IGT:2:".length) {
            cachHeaders[realKey] = value;
          } else {
            cachHeaders[realKey] = "";
          }
        } else if (!ignoreIGSetKeys.includes(realKey) && value) {
          cachHeaders[realKey] = value;
        }
      }
    }
  });
  IgSetHeaders.updateUserHeaders(cachHeaders, userId);
};
